
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTvPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 69,
  height: 24,
  viewBox: "0 0 69 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tvPlus_622622b2d4e1343c__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.713.007c.316-.042.516.096.711.33.808.961 1.131 3.327 2.49 3.612 1.116.235 3.388-.21 4.594-.38 1.353-.19 2.891-.546 4.23-.634.408-.026 1.36-.056 1.69.165.116.077.226.236.199.38-.077.424-.688 1.038-1.01 1.327-1.754 1.58-4.209 2.927-5.614 4.82-.67.903-.555 1.175-.11 2.154.98 2.156 2.354 4.308 3.468 6.423.765 1.45 2.072 3.686 2.464 5.22.081.317.06.613-.347.572-.541-.054-1.216-.504-1.681-.784-2.37-1.426-4.645-3.085-6.982-4.572-2.501-1.592-4.235-2.715-7.123-1.08-2.497 1.413-4.82 3.665-7.22 5.295-.222.15-.486.34-.718.467-1.042.575-.774-.223-.545-.866 1.029-2.899 2.49-5.674 3.6-8.532.259-.664.679-1.775.498-2.467-.305-1.164-2.26-1.586-3.097-2.312-.838-.726.212-1.028.784-1.263 1.6-.657 3.388-1.027 4.939-1.751 1.835-.857 2.417-3.393 3.463-4.978.305-.461.716-1.067 1.319-1.146h-.002Z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.315 23.212c-2.898 0-4.627-1.686-4.627-4.512v-8.405h-2.181V8.208h.475c1.145 0 1.945-.813 1.945-1.977V4.02h2.77v3.977h3.765v2.296h-3.765v8.195c0 1.456 1.01 2.396 2.573 2.396.456 0 .92-.07 1.34-.195v2.189c-.699.212-1.52.332-2.297.332l.002.001ZM43.168 23.105 37.622 8h3.039l4.39 12.189L49.409 8h2.769l-5.56 15.105h-3.45ZM59.754 23.223v-6.107a.366.366 0 0 0-.365-.366h-6.485v-2.397h6.485a.366.366 0 0 0 .365-.365V7.879h2.394v6.107c0 .203.165.366.366.366h6.484v2.397h-6.484a.366.366 0 0 0-.366.365v6.109h-2.394Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.422 10.166h-1.666v2.21c0 1.164-.8 1.977-1.945 1.977h-.475v1.191h4.086v-5.378Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tvPlus_622622b2d4e1343c__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h69v24H0z"
})))));

      const __svgRaw = "<svg width=\"69\" height=\"24\" viewBox=\"0 0 69 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_19569_47185)\">\r\n<path d=\"M11.7132 0.00707038C12.0293 -0.0351237 12.2289 0.10271 12.4242 0.336184C13.2321 1.29821 13.5553 3.66389 14.9141 3.94941C16.0298 4.18429 18.3019 3.73843 19.5075 3.56966C20.8607 3.37978 22.3993 3.02254 23.7371 2.93534C24.146 2.90862 25.0972 2.87908 25.4275 3.0999C25.5441 3.17725 25.6537 3.33618 25.627 3.47964C25.5497 3.9044 24.9385 4.51762 24.6167 4.80735C22.8631 6.38682 20.4083 7.73421 19.0031 9.62732C18.3328 10.5303 18.4481 10.8017 18.8935 11.7806C19.8729 13.9367 21.2471 16.0886 22.3614 18.204C23.1258 19.654 24.4326 21.8903 24.8246 23.4234C24.9061 23.7412 24.8851 24.0366 24.4776 23.9958C23.9366 23.9424 23.2621 23.4923 22.797 23.2124C20.4279 21.7863 18.1516 20.1266 15.8148 18.64C13.3136 17.0479 11.5797 15.9255 8.69209 17.5598C6.19513 18.9733 3.87242 21.2251 1.47242 22.8552C1.2504 23.0057 0.986235 23.1941 0.754385 23.3221C-0.288238 23.8974 -0.0198543 23.0985 0.209186 22.4557C1.23776 19.557 2.69912 16.782 3.80919 13.9241C4.06773 13.2602 4.48787 12.1491 4.30661 11.4571C4.00169 10.2926 2.04712 9.87064 1.20965 9.1449C0.372183 8.41917 1.42183 8.11678 1.99373 7.8819C3.5942 7.22507 5.38155 6.85517 6.93284 6.13084C8.76797 5.2743 9.3497 2.73843 10.3965 1.15334C10.7015 0.692021 11.1118 0.0858327 11.7146 0.00707038H11.7132Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M33.3148 23.2123C30.4174 23.2123 28.6876 21.5259 28.6876 18.7003V10.2953H26.5068V8.20806H26.9818C28.127 8.20806 28.9265 7.39512 28.9265 6.23056V4.021H31.6975V7.99849H35.4619V10.2939H31.6975V18.4894C31.6975 19.945 32.7078 20.8846 34.2703 20.8846C34.7256 20.8846 35.1907 20.8157 35.6108 20.6905V22.8789C34.9111 23.0913 34.0904 23.2109 33.3134 23.2109L33.3148 23.2123Z\" fill=\"white\"/>\r\n<path d=\"M43.1677 23.1055L37.6216 8H40.6609L45.0506 20.1885L49.4094 8H52.1776L46.6174 23.1055H43.1677Z\" fill=\"white\"/>\r\n<path d=\"M59.7539 23.2226V17.1157C59.7539 16.9131 59.5895 16.75 59.3886 16.75H52.9038V14.3534H59.3886C59.5909 14.3534 59.7539 14.1888 59.7539 13.9877V7.87939H62.1483V13.9863C62.1483 14.1888 62.3127 14.352 62.5136 14.352H68.9984V16.7486H62.5136C62.3113 16.7486 62.1483 16.9132 62.1483 17.1143V23.2226H59.7539Z\" fill=\"white\"/>\r\n<path d=\"M61.4221 10.166H59.7556V12.3756C59.7556 13.5401 58.9561 14.3531 57.8109 14.3531H57.3359V15.5444H61.4221V10.1674V10.166Z\" fill=\"white\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_19569_47185\">\r\n<rect width=\"69\" height=\"24\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tvPlus.622622b2d4e1343cfeca4f65448acbc3.svg"),
        {
          React: SvgTvPlus,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      